// What was read from the customer's photo (2026-10-19, prod contact 7715882;
// docs/image-label-read.md): the line the AI Suggestion panel shows, and which
// of the conversation's own images it came from. The suggestion stores only a
// reference ({ kind, messageId, mediaIndex | attachmentId }), never a URL.
// Pure, so ui/test can run it.

// The photo VIN that failed the check digit (2026-10-21), or null. It is never
// used: the server keeps it only so the person can check the photo. A VIN
// stored unverified before that rule counts too.
export function photoVinUnverified(read) {
  if (!read) return null
  if (read.vinUnverified) return read.vinUnverified
  return read.vin && read.vinVerified !== true ? read.vin : null
}

// "Read from customer photo: VIN WBAEV53403KM28627 → 2003 BMW 330i", plus any
// part numbers; "Couldn't verify VIN …: check the photo" for a VIN that failed
// the check digit; null when nothing usable was read.
export function photoLabelText(read) {
  if (!read) return null
  const unverified = photoVinUnverified(read)
  const parts = []
  if (read.vin && !unverified) parts.push(`VIN ${read.vin}${read.vehicle ? ` → ${read.vehicle}` : ''}`)
  if (read.partNumbers?.length) parts.push(`part number${read.partNumbers.length === 1 ? '' : 's'} ${read.partNumbers.join(', ')}`)
  const lines = []
  if (parts.length) lines.push(`Read from customer photo: ${parts.join('; ')}`)
  if (unverified) lines.push(`Couldn't verify VIN ${unverified}: check the photo`)
  return lines.length ? lines.join('. ') : null
}

// The image the value came from, among the conversation's messages:
// { kind: 'ebay', url } or { kind: 'attachment', attachmentId }, or null.
export function photoLabelImage(read, messages) {
  const ref = read?.imageRef
  if (!ref) return null
  const message = (messages ?? []).find((m) => m?.id === ref.messageId)
  if (!message) return null
  if (ref.kind === 'ebay') {
    const url = message.metadata?.media?.[ref.mediaIndex]?.url
    return url ? { kind: 'ebay', url } : null
  }
  if (ref.kind === 'attachment') {
    return (message.attachments ?? []).some((a) => a?.id === ref.attachmentId) ? { kind: 'attachment', attachmentId: ref.attachmentId } : null
  }
  return null
}
